import React from 'react';
import { useSelector } from 'react-redux';
import { useHeaderBarItemData } from 'cityads-v3/hooks/header';
import { USER_ROLE_CODE_WEBMASTER } from 'cityads-v3/reducers/auth';
import { RootState } from 'cityads-v3/types/reducer';

import { WidgetCode, SupportHeaderBarItemData } from './types';
import CarrotquestWidget from './CarrotquestWidget';
import RedmineWidget from './RedmineWidget';

export default function SupportWidget(): React.ReactElement {
  const userRoleCode = useSelector((state: RootState) => state.auth.user?.user_role_code);
  const isAuthChecked = useSelector((state: RootState) => state.auth.isAuthChecked);

  const headerWidgetData = useHeaderBarItemData<SupportHeaderBarItemData>('support');

  const isWidgetOn = isAuthChecked && (!userRoleCode || userRoleCode === USER_ROLE_CODE_WEBMASTER);

  if (!isWidgetOn) {
    return null;
  }

  switch (headerWidgetData?.widget) {
    case WidgetCode.Carrotquest:
      return <CarrotquestWidget {...headerWidgetData?.widgets?.[WidgetCode.Carrotquest]} />

    case WidgetCode.Redmine:
    default:
      return (<RedmineWidget {...headerWidgetData?.widgets?.[WidgetCode.Redmine]} />);
  }
}
